module.exports = __webpack_public_path__ + "img/zlindex18.8a02e515.png";